import {
  IMienGiamSoTienDuyetRequest,
  IMienGiamSoTienPagingRequest,
  IMienGiamSoTienSaveRequest,
} from "../../../model/request/mien-giam/IMienGiamSoTienRequest";
import { IMienGiamSoTien } from "../../../model/respone/mien-giam/IMienGiamSoTien";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMienGiamSoTienActionsObj = {
  CHANGE_REQUEST: {} as IMienGiamSoTienPagingRequest,
  LOAD_START: {} as IMienGiamSoTienPagingRequest,
  LOAD_SUCCESS: {} as IMienGiamSoTien[],
  LOAD_ERROR: "",

  CHANGE_SELECTED_IDS: [] as number[],

  SHOW_EDIT_MODAL: {} as IMienGiamSoTien | undefined,
  HIDE_EDIT_MODAL: undefined,
  SHOW_IMPORT_MODAL: undefined,
  HIDE_IMPORT_MODAL: undefined,

  SAVE_START: {} as IMienGiamSoTienSaveRequest,
  SAVE_SUCCESS: "",
  SAVE_ERROR: "",

  DUYET_START: {} as IMienGiamSoTienDuyetRequest,
  DUYET_SUCCESS: "",
  DUYET_ERROR: "",

  DELETE_START: [] as number[],
  DELETE_SUCCESS: "",
  DELETE_ERROR: "",
};

export const eMienGiamSoTienActionIds = generateActionTypeIds(
  eMienGiamSoTienActionsObj,
  "MIEN_GIAM_SO_TIEN",
);

export type IMienGiamSoTienActionTypes = IGenericActionType<
  typeof eMienGiamSoTienActionsObj,
  "MIEN_GIAM_SO_TIEN"
>;
